import {
  createRoutesResourceGuard,
  deleteRoutesResourceGuard,
  editRoutesResourceGuard,
  routesCollectionGuard,
  routesResourceGuard,
} from './_api/sortingMaps';

export const resourceSortingMapsRoutes = routesResourceGuard;
export const deleteSortingMapsRoutes = deleteRoutesResourceGuard;
export const createSortingMapsRoutes = createRoutesResourceGuard;
export const collectionSortingMapsRoutes = routesCollectionGuard;
export const editSortingMapsRoutes = editRoutesResourceGuard;

export const routeGuard = routesCollectionGuard;
